
define('text!areas/home/views/dashboard.html',[],function () { return '<md-module id="dashboard">\r\n\r\n</md-module>\r\n';});

